import React, {memo, useEffect, useState} from "react";
import {Pie} from "react-chartjs-2";
import {getTypeOfBusinessStatistics} from "../../../api/admin";
import {getData} from "./colors";

const TypeOfBusiness = (submissionType) => {
  const [typeOfBusiness, setTypeOfBusiness] = useState([]);
  useEffect(() => {
    getTypeOfBusinessStatistics(submissionType).then((data) => {
      setTypeOfBusiness(data);
    });
  }, [submissionType]);

  const typeOfBusinessData = (typeOfBusiness && typeOfBusiness.data) || [];
  const labels = typeOfBusinessData.map((c) => c._id) || [];
  const data = typeOfBusinessData.map((c) => c.count) || [];

  return <Pie data={getData({labels, data})} type="pie" />;
};

export default memo(TypeOfBusiness);
